import { capitalDesignTokens, createTypedSxStyles } from "@opengov/capital-mui-theme";

const { semanticColors, foundations } = capitalDesignTokens;

export const styles = createTypedSxStyles({
  selectControls: {
    marginTop: "8px",
    marginBottom: "20px",
    padding: "16px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: semanticColors.background.secondary,
    border: `1px solid ${semanticColors.foreground.action}`,
    borderRadius: "4px",
  },
  groupLabel: {
    display: "block",
    fontSize: "11px",
    fontWeight: foundations.typography.fontWeight.semiBold,
    color: semanticColors.foreground.secondary,
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    lineHeight: "16px",
    marginBottom: "8px",
  },
  toolbarSelectionInfo: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },
  divider: {
    marginLeft: "4px",
    marginRight: "4px",
    height: "16px",
    borderLeft: `1px solid ${semanticColors.border.secondary}`,
  },
  unselectButton: {
    fontSize: "12px",
    cursor: "pointer",
    color: semanticColors.foreground.action,
    background: "transparent",
    border: 0,
    padding: 0,
    display: "inline",
    fontFamily: "inherit",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  buttons: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
});
